import { useCallback } from "react";
import { useAccessorUpdateSubscription } from "./useAccessorUpdateSubscription.js";
import { useEntityListSubTreeParameters } from "./useEntityListSubTreeParameters.js";
import { useGetEntityListSubTree } from "./useGetEntityListSubTree.js";
const useEntityListSubTree = (qualifiedEntityList, ...treeId) => {
  const getSubTree = useGetEntityListSubTree();
  const parameters = useEntityListSubTreeParameters(qualifiedEntityList);
  const hasTreeId = treeId.length > 0;
  const treeIdVal = treeId[0];
  const getAccessor = useCallback(
    () => getSubTree(parameters, ...hasTreeId ? [treeIdVal] : []),
    [getSubTree, hasTreeId, parameters, treeIdVal]
  );
  return useAccessorUpdateSubscription(getAccessor);
};
export {
  useEntityListSubTree
};
//# sourceMappingURL=useEntityListSubTree.js.map
